var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',_vm._l((_vm.nodes),function(node,index){return _c('li',{key:index,staticClass:"navbar-item",class:node.class},[_c('click-dropdown',{attrs:{"toggleArrow":_vm.toggleArrow,"node":node}},[_vm._t("default")],2)],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }